import { createSlice } from '@reduxjs/toolkit';

const initialState = { agentSuggestions: [] };

const agentSuggestionsSlice = createSlice({
  name: 'agentSuggestions',
  initialState,
  reducers: {
    subscriptionListHandler(state, action) {
      state.agentSuggestions = action.payload.suggestionsListData;
    },
  },
});
export const agentSuggestionsAction = agentSuggestionsSlice.actions;
export default agentSuggestionsSlice;